import { sides, sidesUpperCase } from '../../../../models/product-detail';

export const isAvailableForSide = (
    side: string,
    isAvailableLeft: boolean,
    isAvailableRight: boolean
) => {
    if (
        (side === sidesUpperCase.binaural || side === sides.binaural) &&
        (isAvailableLeft || isAvailableRight)
    ) {
        return true;
    }
    if (
        (side === sidesUpperCase.left || side === sides.left) &&
        isAvailableLeft
    ) {
        return true;
    }
    if (
        (side === sidesUpperCase.right || side === sides.right) &&
        isAvailableRight
    ) {
        return true;
    }
    return false;
};
